import ms from 'ms'
import _isString from 'lodash/isString'

export const QUERY_POLL_INTERVAL = ms(_isString(window.__USECURE_CONFIG__.REACT_APP_QUERY_POLL_INTERVAL) ? window.__USECURE_CONFIG__.REACT_APP_QUERY_POLL_INTERVAL : '30s')

export const LONG_QUERY_POLL_INTERVAL = ms(_isString(window.__USECURE_CONFIG__.REACT_APP_LONG_QUERY_POLL_INTERVAL) ? window.__USECURE_CONFIG__.REACT_APP_LONG_QUERY_POLL_INTERVAL : '120s')
